import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import FormControlLabel from 'housecall-ui/dist/DesignSystem/Inputs/FormControls/FormControlLabel';
import Switch from 'housecall-ui/dist/DesignSystem/Inputs/Switches/Switch';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';

import { getAppEnabled } from '../../../../Resources/Organization/Apps/AppsData';
import { MEASUREQUICK } from '../AppsData';
import { toggleEnabledWithEntity } from '../Redux/Actions';

const MeasureQuickButton = () => {
  const appEnabled = useSelector(getAppEnabled(MEASUREQUICK));
  const appConfiguration = useSelector((state) => state.appConfiguration);
  const dispatch = useDispatch();
  const loginUrl = appConfiguration.login_url;
  const oauthEnabled = appConfiguration.oauth_enabled;

  const handleToggleAppEnabled = () => {
    dispatch(toggleEnabledWithEntity(MEASUREQUICK));
  };

  return (
    <Grid container>
      {appEnabled && (
        <Grid item>
          <FormControlLabel
            control={<Switch checked={appEnabled} onChange={handleToggleAppEnabled} />}
            label="Active"
          />
        </Grid>
      )}
      {(!oauthEnabled || !appEnabled) && (
        <Grid container>
          <Grid item>
            <a href={loginUrl} target="_blank" rel="noreferrer noopener">
              <Button variant="contained" color="primary">
                Enable measureQuick
              </Button>
            </a>
          </Grid>
        </Grid>
      )}
      Enabling this toggle will share your contact information with the partner
    </Grid>
  );
};

export default MeasureQuickButton;
